<template>
  <v-sheet elevation="0" class="ma-2 px-2 h85" v-if="key">
    <v-row class="mb-5">
      <v-col>
        <BackBtn to="/keys" />
      </v-col>
      <!-- <Title
        v-model="key.name"
        empty="Insert a new API Key name..."
        icon="key-chain-variant"
        editable
      />
      <v-spacer></v-spacer> -->
    </v-row>
    <v-card class="ma-1 pa-1 scrollable h75" elevation="4">
      <v-row class="ma-1">
        <v-col>
          <v-row>
            <v-col>
              <h4><v-icon>mdi-key-chain-variant</v-icon> General:</h4>
            </v-col>
          </v-row>
          <v-row class="my-1">
            <v-col>
              <v-text-field
                v-model="key.name"
                label="API Key Name"
                :rules="rules.text"
                required
                dense
              >
              </v-text-field>
            </v-col>
            <v-divider vertical> </v-divider>
            <v-col>
              <v-row class="mt-1">
                <v-col cols="auto">
                  <v-switch class="my-0" color="success" v-model="key.active">
                  </v-switch>
                </v-col>
                <v-col cols="auto">
                  <h4 class="my-1"><v-icon>mdi-power</v-icon> Active</h4>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider> </v-divider>
          <v-row class="mt-1">
            <v-col>
              <h4><v-icon>mdi-card-text</v-icon> Description:</h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea solo v-model="key.description" label="Description">
              </v-textarea>
            </v-col>
          </v-row>
          <v-divider> </v-divider>
          <h4><v-icon>mdi-cloud-braces</v-icon> Sources/Whitelist:</h4>
          <v-row class="mt-1">
            <v-col cols="auto">
              <v-select
                label="Source Type"
                outlined
                :items="['ip', 'domain']"
                dense
                v-model="currentSourceType"
              >
              </v-select>
            </v-col>
            <v-col>
              <v-text-field
                label="Add Source"
                outlined
                dense
                :rules="rules[currentSourceType]"
                v-model="currentSource"
                @keypress:enter="addSource"
              >
              </v-text-field>
            </v-col>
            <v-col cols="auto">
              <v-btn
                color="success"
                fab
                x-small
                class="mt-1"
                :disabled="!validateSource"
                @click="addSource"
              >
                <v-icon>mdi-plus</v-icon></v-btn
              >
            </v-col>
          </v-row>
          <v-list outlined>
            <v-list-item
              v-if="key.source && !key.source.length"
              class="text-center"
            >
              <v-icon small>mdi-cancel</v-icon> &nbsp;Sources/whitelist is
              empty</v-list-item
            >
            <v-list-item v-for="(source, i) in key.source" :key="source">
              <v-list-item-content>{{ source }}</v-list-item-content>
              <v-list-item-action>
                <v-btn x-small fab text color="error" @click="deleteSource(i)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <!-- <v-row>
            <v-col>
              <KeysGeneratorDialog :apiKey="key.hash" />
            </v-col>
          </v-row> -->
        </v-col>
        <v-divider vertical> </v-divider>
        <v-col>
          <v-row>
            <v-col>
              <h4><v-icon>mdi-cloud-lock</v-icon> Permissions/Actions:</h4>
            </v-col>
          </v-row>
          <section v-if="key.actions">
            <v-row>
              <v-col>
                <!-- <v-chip-group column multiple v-model="key.actions">
                  <v-chip
                    filter
                    outlined
                    v-for="action in actions"
                    :key="action.text"
                  >
                    {{ action.text }}
                  </v-chip>
                </v-chip-group> -->

                <!-- <v-combobox
                  :items="actions"
                  v-model="key.actions"
                  label="Search & Select Permissions/Actions"
                  outlined
                  clearable
                  chips
                  multiple
                >
                </v-combobox> -->
                <v-treeview
                  open-all
                  selectable
                  v-model="key.actions"
                  item-disabled="locked"
                  :items="actions"
                ></v-treeview>
              </v-col>
            </v-row>
            <!-- <DragList :list="key.actions" @changed="updateList">
              <template v-slot:title>
                <v-icon>mdi-order-bool-ascending-variant</v-icon> Plans Order:
              </template>
              <template v-slot:icon>
                <v-icon>mdi-test-tube</v-icon>
              </template>
            </DragList> -->
          </section>
          <v-divider v-if="!fresh"> </v-divider>
          <v-row class="my-1" v-if="!fresh">
            <v-col cols="auto">
              <h4><v-icon>mdi-key-variant</v-icon> API Key:</h4>
            </v-col>
            <v-col>{{ key.hash }}</v-col>
            <v-col cols="auto">
              <CopyToClip
                :text="key.hash"
                :tooltip="'Copy API key to clipboard'"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-spacer> </v-spacer>
      <v-col cols="auto">
        <v-hover v-slot="{ hover }">
          <v-btn
            class="ma-3"
            color="orange"
            :outlined="!hover"
            :dark="hover"
            @click="snippetDialog = true"
          >
            Open Example Snippet <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </v-hover>
      </v-col>
      <v-col cols="auto">
        <v-btn
          class="ma-3"
          :disabled="!valid"
          label="Save"
          color="success"
          @click="save"
        >
          <v-icon dark> mdi-content-save </v-icon> Save
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="snippetDialog" max-width="80vw" max-height="80vh">
      <KeysGeneratorDialog
        class="pa-5"
        :apiKey="key.hash"
        @close="snippetDialog = false"
      />
    </v-dialog>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";

import BackBtn from "../components/buttons/BackBtn.vue";
import CopyToClip from "../components/CopyToClip.vue";
// import Title from "../components/Title.vue";
import { validations, regexes } from "../utils";
import KeysGeneratorDialog from "@/components/dialogs/KeysGeneratorDialog.vue";
import { Key, SelectItem } from "@/types";

export default Vue.extend({
  name: "KeyView",
  components: {
    BackBtn,
    CopyToClip,
    KeysGeneratorDialog,
  },
  data() {
    return {
      rules: {
        text: [
          (val: string) => (val && val.length) || "This field is required",
        ],
        host: [validations.host],
        domain: [validations.domain],
        ip: [validations.ip],
        // empty: [validations.empty],
      },
      currentSource: "",
      currentSourceType: "domain",
      fresh: true,
      snippetDialog: false,
    };
  },
  computed: {
    valid(): boolean {
      return (
        this.key?.name?.length > 0 &&
        this.key?.actions?.length > 0 &&
        this.key?.source?.length > 0
      );
    },
    key(): Key {
      const key: Key = this.$store.getters["Keys/getCurrentKey"];
      this.$store.commit(
        "setTitle",
        key._id ? `Edit '${key.name}'` : "Add New API Key"
      );
      return key;
    },
    actions(): SelectItem[] {
      const actions = this.$store.getters["Keys/getActions"];
      return actions;
    },
    validateSource() {
      if (this.currentSourceType && this.currentSource) {
        const { ip, domain } = regexes.host;
        return this.currentSourceType === "ip"
          ? ip.test(this.currentSource)
          : this.currentSource === "localhost" ||
              domain.test(this.currentSource);
      }
      return false;
    },
  },
  methods: {
    addSource() {
      this.key.source.push(this.currentSource);
      this.currentSource = "";
    },
    deleteSource(index: number) {
      this.key.source.splice(index, 1);
    },
    // updateList(list: any) {
    //   this.key.actions = list;
    // },
    // keyChanged() {
    //   this.$store.commit("Keys/setCurrentKey", this.key);
    // },
    save() {
      // modify actions list to string[]
      this.$store.dispatch("Keys/saveKey", this.key);
      this.$store.commit("Keys/setCurrentKey", {});
      this.$router.push("/keys");
    },
  },

  async mounted() {
    this.$store.commit("Keys/setCurrentKey");
    this.$store.commit("setGlobalLoader", true);
    const { id } = this.$route.params;
    if (id) {
      this.fresh = false;
      await this.$store.dispatch("Keys/fetchCurrentKey", id);
    }
    this.$store.commit("setGlobalLoader");
  },
  destroyed() {
    this.$store.commit("Keys/setCurrentKey");
  },
});
</script>
